import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/utils/app';
import { FormattedMessage } from 'react-intl';

class DisplayName extends React.Component {
    constructor(props) {
        super(props);
    }

    getClasses() {
        const variations = [...this.props.variations];

        if (this.props.isLinked && this.props.user.profileUrl) {
            variations.push('link');
        }

        if (this.props.isTruncated) {
            variations.push('truncate');
        }

        return getComponentClasses('display-name', variations);
    }

    displayName() {
        if (this.props.user.isActive) {
            return <FormattedMessage id="own_username" />;
        } else if (this.props.isTruncated) {
            return this.truncate(this.props.user.name);
        } else {
            return this.props.user.name;
        }
    }

    truncate(name) {
        return this.props.user.name
            .split('')
            .slice(0, this.props.limit)
            .join('');
    }

    render() {
        if (this.props.isLinked && this.props.user.profileUrl) {
            return (
                <a className={this.getClasses()} href={this.props.user.profileUrl}>
                    {this.displayName()}
                </a>
            );
        } else {
            return <span className={this.getClasses()}>{this.displayName()}</span>;
        }
    }
}

DisplayName.propTypes = {
    user: PropTypes.shape({
        name: PropTypes.string.isRequired,
        profileUrl: PropTypes.string,
        isActive: PropTypes.bool,
    }),
    variations: PropTypes.array,
    isLinked: PropTypes.bool,
    isTruncated: PropTypes.bool,
    limit: PropTypes.number,
};

DisplayName.defaultProps = {
    user: {
        profileUrl: null,
        isActive: false,
    },
    variations: [],
    isLinked: true,
    isTruncated: false,
    limit: 20,
};

export default DisplayName;



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/DisplayName.jsx